<script setup>
import { useProjectStore } from '@/store/project'

const projectStore = useProjectStore()

const projectLogos = projectStore.projectImages
    .filter((image) => image.category === 'projectLogo')
    .map((image) => {
        const imageUrl = `${projectStore.project.assetRoot}/images/${image.category}/${image.filename}`
        return { ...image, url: imageUrl }
    })
</script>
<template>
    <div v-if="projectLogos.length > 0" class="logo-banner-container pa-8 mt-9 mt-sm-5">
        <v-container class="flex-column">
            <v-row class="d-flex flex-row justify-space-around">
                <div class="logo-container">
                    <img
                        v-for="image of projectLogos"
                        :key="image.id"
                        class="logo-image mx-2 my-1 mx-sm-4 my-sm-2"
                        :src="image.url"
                        :alt="image.filename"
                    />
                </div>
            </v-row>
        </v-container>
    </div>
    <div v-else />
</template>
<style scoped>
.logo-container {
    text-align: center;
}
.logo-image {
    max-width: 100%;
    max-height: 50px;
    vertical-align: middle;
}
.flex-column {
    max-width: 1185px !important;
}

@media (min-width: 1185px) {
    .flex-column {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
